import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NSwagMigrationInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const zone = Zone.current;
        if (zone.name === 'NSwag Migration') {
            const data = zone.get('data') ?? {};
            if (!data.handled) {
                const header = `service="${data.service}", method="${data.method}", flag="${data.flag}", enabled=${data.enabled}`
                request = request.clone({ setHeaders: { 'X-NSwag-Migration': header } });
                data.handled = true;
            }
        }

        return next.handle(request);
    }
}
